module.exports = __webpack_public_path__ + "img/uz.138ef0ca.svg";